export default __webpack_public_path__ + "static/media/place_holder_ discover.ab13023c.svg";